<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Size</span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="rounded-slider"
        v-model="size"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="sizeClasses"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { InputSizeClasses } from '../classes/InputSizeClasses'
  export default MenuStyleProperty.extend({
    computed: {
      sizeClasses() {
        return Object.keys(InputSizeClasses)
      },
      size: {
        get() {
          let currentSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
            if (! currentSize) {
              currentSize = {property: 'InputSize', value: 'INPUT_SIZE_MD', touched: false}
              this.addToArray(this.module, [currentSize], this.classes, this.device, {}, true, this.parentModule)
            }
            return currentSize.value
        },
        set: _.debounce(function (value) {
          let currentSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.sizeClasses.includes(elementClass.value))
          value = {property: 'InputSize', value: value, touched: currentSize.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>